export const getReportPath = (reportType) => {
  switch (reportType) {
    case "immunisations":
      return "get/immunisations";
    case "prescriptions":
      return "get/prescriptions";
    case "investigations":
      return "get/invesgigations";
    case "letters":
      return "get/letters";
    case "accounting":
      return "get/accounting";
    case "appointments":
      return "get/appointments";
    case "medico-legal":
      return "get/medico-legal";
    case "audit-log":
      return "get/auditlog";
    case "cdm-finder":
      return "get/cdm-finder";
    case "cdm-recall":
      return "get/cdm-recall";
    case "cdm-register":
      return "get/cdm-register";
    default:
      return "get/patients";
  }
};
